export default "__VITE_ASSET__DF4P_DUo__"